export default (length: number) => {
	return randomString(length, '0123456789abcdefghijklmnopqrstuvwxyz')
}

// Random alpha-numeric string in JavaScript
// https://stackoverflow.com/questions/10726909/random-alpha-numeric-string-in-javascript

function randomString(length: any, chars: any) {
	var result = ''
	for (var i = length; i > 0; --i)
		result += chars[Math.floor(Math.random() * chars.length)]
	return result
}
